<template>
  <div class="blackList-list-page">
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header" class="blackList-header">
        <div class="blackList-header-top">
          <h3 class="blackList-header-left">
            黑名单总数：{{ total ? total : 0 }}
          </h3>
          <div class="blackList-header-right">
            <button class="global-button-style" @click="syncBlacklist()">
              一键同步
            </button>
            <button
              class="global-button-style"
              @click="getModelBlacklist(), (showModelBlackList = true)"
            >
              型号过滤
            </button>
            <button class="global-button-style" @click="search()">
              {{ $t('commonMsg.search') }}
            </button>
            <button class="global-button-style" @click="remove">
              {{ $t('commonMsg.remove') }}
            </button>
          </div>
        </div>
        <div class="blackList-header-bottom">
          <div class="blackList-header-bottom-first">
            <div class="left-part">
              <span>账号ID</span>
              <div class="listSearch">
                <el-input
                  v-model="searchParams.accountId"
                  clearable
                  @keyup.enter.native="search"
                  @clear="clearSearch('accountId')"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
            <div class="left-part">
              <span>名称</span>
              <div class="listSearch">
                <el-input
                  v-model="searchParams.name"
                  clearable
                  @keyup.enter.native="search"
                  @clear="clearSearch('name')"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
            <div class="left-part">
              <span>{{ $t('user.phone') }}</span>
              <div class="listSearch">
                <el-input
                  v-model="searchParams.phone"
                  clearable
                  @keyup.enter.native="search"
                  @clear="clearSearch('phone')"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
            <div class="left-part">
              <span>{{ $t('user.email') }}</span>
              <div class="listSearch">
                <el-input
                  v-model="searchParams.email"
                  clearable
                  @keyup.enter.native="search"
                  @clear="clearSearch('email')"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
          </div>
          <div class="blackList-header-bottom-second">
            <div class="left-part">
              <span>型号</span>
              <div class="listSearch">
                <el-input
                  v-model="searchParams.model"
                  clearable
                  @keyup.enter.native="search"
                  @clear="clearSearch('model')"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
            <div class="left-part">
              <span>{{ $t('user.mac') }}</span>
              <div class="listSearch">
                <el-input
                  v-model="searchParams.mac"
                  clearable
                  @keyup.enter.native="search"
                  @clear="clearSearch('mac')"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
            <div class="left-part">
              <span>序列号</span>
              <div class="listSearch">
                <el-input
                  v-model="searchParams.sn"
                  clearable
                  @keyup.enter.native="search"
                  @clear="clearSearch('sn')"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <Table
          :tableProps="tableProps"
          :tableData="tableData"
          :currentPage="paramsList.page"
          :pageSize="paramsList.limit"
          @tableHandle="tableHandle"
          :selectCtrl="true"
          @tableSelection="tableSelection"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
      />
    </el-card>

    <el-dialog
      :title="`型号黑名单（${modelCount}）`"
      :visible.sync="showModelBlackList"
      width="200"
      @close="closeModelBlackList"
    >
      <div class="modelBlackList-main">
        <div class="modelBlackList-header">
          <el-checkbox
            v-model="modelAllCheck"
            label="全选"
            :indeterminate="modelIndeterminate"
            @change="onModelAllCheck"
          ></el-checkbox>
          <div class="modelBlackList-header-right">
            <ListSearch ref="modelSearch" @listSearchEvn="modelSearchEvn" />
            <button class="global-button-style" @click="batDelModelBlacklist">
              删除
            </button>
          </div>
        </div>
        <div class="modelBlackList-list" v-bar>
          <div>
            <div
              class="modelBlackList-item"
              v-for="item in modelList"
              :key="item._id"
            >
              <div class="modelBlackList-item-left">
                <el-checkbox
                  v-model="item.check"
                  @change="onItemCheck"
                ></el-checkbox>
                <span>
                  {{ item.model }}
                </span>
              </div>
              <i class="el-icon-delete" @click="delModelBlacklist(item)"></i>
            </div>
          </div>
        </div>
        <div class="modelBlackList-createBtn">
          <el-input
            v-model.trim="models"
            placeholder="(多种型号用\隔开)"
            @keyup.enter.native="addModelBlacklist"
          >
          </el-input>
          <button class="global-button-style" @click="addModelBlacklist">
            添加
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Table from './components/table'
import Pagination from '@/components/pagination'
import ListSearch from '@/components/listSearch'
export default {
  name: 'blackList',
  props: ['refresh'],
  components: {
    Table,
    Pagination,
    ListSearch
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: 'accountId',
          label: '账号ID'
        },
        {
          prop: 'name',
          label: '名称'
        },
        {
          prop: 'phone',
          label: '手机'
        },
        {
          prop: 'email',
          label: '邮箱'
        },
        {
          prop: 'model',
          label: '型号'
        },
        {
          prop: 'mac',
          label: 'MAC'
        },
        {
          prop: 'sn',
          label: '序列号'
        },
        {
          prop: 'updatedAt',
          label: '更新日期'
        },
        {
          prop: 'handle',
          label: this.$t('org.manage'),
          btn: [this.$t('commonMsg.remove')]
        }
      ]
      return tableProps
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      size: '',
      model: '',
      paramsList: {
        limit: 20,
        page: 1
      },
      currentItem: null,
      timer: null,
      selectData: [],
      searchParams: {
        accountId: '',
        name: '',
        phone: '',
        email: '',
        mac: '',
        sn: '',
        model: ''
      },
      modelParams: {
        limit: 10000
      },
      showModelBlackList: false,
      modelList: [],
      modelCount: 0,
      selectModel: [],
      models: '',
      modelAllCheck: false,
      modelIndeterminate: false
    }
  },
  methods: {
    async getBlacklists() {
      try {
        let res = await this.$http.getBlacklists(this.paramsList)
        this.total = res.data.count
        this.tableData = res.data.results
        this.selectData = []
      } catch (error) {}
    },

    inputHandleSeach() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.search()
      }, 1000)
    },

    tableHandle({ type, data }) {
      if (type === this.$t('commonMsg.remove')) {
        this.removeSingle(data.row)
      }
    },

    async removeSingle(data) {
      await this.$confirm(null, '确认要移出黑名单？', {
        confirmButtonText: this.$t('commonMsg.confirm'),
        cancelButtonText: this.$t('commonMsg.cancel'),
        showClose: false,
        center: true
      })
      await this.$http.delBlacklists({ ids: data._id })
      this.getBlacklists()
    },

    tableSelection(data) {
      this.selectData = data
    },

    async remove() {
      try {
        if (!this.selectData.length) return
        await this.$confirm(null, '确认要移出黑名单？', {
          confirmButtonText: this.$t('commonMsg.confirm'),
          cancelButtonText: this.$t('commonMsg.cancel'),
          showClose: false,
          center: true
        })
        let ids = this.selectData.map((item) => item._id)
        await this.$http.delBlacklists({ ids })
        this.getBlacklists()
      } catch (error) {}
    },

    pageNum(val) {
      this.paramsList.page = val
      this.getBlacklists()
    },

    search() {
      for (let type in this.searchParams) {
        if (this.searchParams[type]) {
          this.paramsList[type] = this.searchParams[type]
        } else {
          delete this.paramsList[type]
        }
      }
      this.paramsList.page = 1
      this.getBlacklists()
    },

    clearSearch(type) {
      this.searchParams[type] = ''
      delete this.paramsList[type]
      this.paramsList.page = 1
      this.getBlacklists()
    },

    async syncBlacklist() {
      try {
        await this.$http.syncBlacklists()
        this.elMsg('同步成功', 'success')
      } catch (error) {
        this.elMsg(error, 'error')
      }
    },

    async getModelBlacklist() {
      let res = await this.$http.getModelBlacklist(this.modelParams)
      for (let item of res.data.results) {
        item.check = false
      }
      this.modelCount = res.data.count
      this.modelList = res.data.results
    },

    async addModelBlacklist() {
      if (!this.models) return
      let datas = this.models.split('\\').filter((item) => item && item.trim())
      await this.$http.addModelBlacklist({ datas })
      if (this.modelParams.model) {
        this.$refs.modelSearch.clearValue()
        this.modelSearchEvn()
      } else {
        this.getModelBlacklist()
        this.initModelData()
      }
    },

    async delModelBlacklist(item) {
      this.selectModel = [item]
      this.batDelModelBlacklist()
    },

    async batDelModelBlacklist() {
      if (!this.selectModel.length) return
      await this.$confirm(null, '确认要移出黑名单？', {
        confirmButtonText: this.$t('commonMsg.confirm'),
        cancelButtonText: this.$t('commonMsg.cancel'),
        showClose: false,
        center: true
      })
      let ids = this.selectModel.map((item) => item._id)
      await this.$http.batDelModelBlacklist({ ids })
      this.getModelBlacklist()
      this.initModelData()
    },

    closeModelBlackList() {
      this.initModelData()
    },

    async modelSearchEvn(val) {
      if (val) {
        this.modelParams.model = val
      } else {
        delete this.modelParams.model
      }
      this.initModelData()
      this.getModelBlacklist()
    },

    onModelAllCheck() {
      if (this.modelAllCheck) {
        for (let item of this.modelList) {
          item.check = true
        }
      } else {
        for (let item of this.modelList) {
          item.check = false
        }
      }
      this.onItemCheck()
    },

    onItemCheck() {
      this.selectModel = this.modelList.filter((item) => item.check)
      this.checkIndeterminate()
    },

    checkIndeterminate() {
      if (
        this.selectModel.length &&
        this.selectModel.length !== this.modelList.length
      ) {
        this.modelIndeterminate = true
        this.modelAllCheck = false
      } else if (
        this.selectModel.length &&
        this.selectModel.length === this.modelList.length
      ) {
        this.modelIndeterminate = false
        this.modelAllCheck = true
      } else {
        this.modelIndeterminate = false
        this.modelAllCheck = false
      }
    },

    initModelData() {
      this.modelAllCheck = false
      this.modelIndeterminate = false
      this.models = ''
      this.selectModel = []
    }
  },
  watch: {
    refresh() {
      this.getBlacklists()
    }
  },
  mounted() {
    this.getBlacklists()
  }
}
</script>

<style lang="scss" scoped>
.global-header-wrap {
  padding: 10px 44px;
}
.blackList-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .blackList-header {
    .blackList-header-top {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .blackList-header-left {
        flex: 1;
      }
      .blackList-header-right {
        /* flex: 1; */
      }
    }
    .blackList-header-bottom {
      .blackList-header-bottom-first,
      .blackList-header-bottom-second {
        display: flex;
        > .left-part {
          margin-right: 30px;
        }
      }
      .blackList-header-bottom-second {
        margin-top: 10px;
      }
    }
  }
}
.modelBlackList-main {
  height: 440px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .modelBlackList-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 10px;
    border-bottom: 1px solid #eee;
    .modelBlackList-header-right {
      display: flex;
      align-items: center;
    }
  }
  .modelBlackList-list {
    flex: 1;
    .modelBlackList-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 10px;
      border-bottom: 1px solid #eee;
      font-size: 16px;
      font-weight: 500;
      .modelBlackList-item-left {
        display: flex;
        align-items: center;
        > span {
          margin-left: 20px;
        }
      }
      > i {
        color: #ff3939;
        cursor: pointer;
      }
    }
  }
  .modelBlackList-createBtn {
    margin-top: 20px;
    display: flex;
    > .el-input {
      flex: 1;
    }
  }
}
</style>
